$(document).on('click', '.ph-verifycartcontent', function(event) {
  if ($('.quantity-balloon').length > 0) {
    event.preventDefault();

    $.colorbox({
      maxWidth: '630px',
      width: '95%',
      height: 'auto',
      scrolling: true,

      /* eslint-disable xss/no-mixed-html */
      html: $('.ph-shoppingcartswich_popup').html(),
      /* eslint-enable xss/no-mixed-html */
      onComplete: function() {
        $('#cboxContent #cboxClose').addClass('ph-close-popup');
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });

    return false;
  }

  return true;
});
$(document).on('click', '.ph-switch-store', function(event) {
  if ($('.quantity-balloon').length > 0) {
    event.preventDefault();

    $.colorbox({
      maxWidth: '630px',
      width: '95%',
      height: 'auto',
      scrolling: true,

      /* eslint-disable xss/no-mixed-html */
      html: $('.ph-switchstore_popup').html(),
      /* eslint-enable xss/no-mixed-html */
      onComplete: function() {
        $('#cboxContent #cboxClose').addClass('ph-close-popup');
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });

    return false;
  }

  return true;
});
$(document).on('click', '.ph-readmoreflyout', function() {
  $.colorbox({
    maxWidth: '630px',
    width: '95%',
    height: 'auto',
    scrolling: true,
    overlayClose: false,
    onLoad: function() {
      $('#cboxClose').remove();
    },
    /* eslint-disable xss/no-mixed-html */
    html: $('.ph-storespecificflyoutpopup').html(),
    /* eslint-enable xss/no-mixed-html */
    onClosed: function() {
      ACC.common.refreshScreenReaderBuffer();
    }
  });
});
$(document).on('click', '.ph-close-popup', function() {
  $.colorbox.close();
});
